export enum FeatureFlagKey {
  FACEBOOK_AI = 'facebookAi',
  AVAILABLE_WORKERS = 'availableWorkers',
}
